/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable max-len */

import React, {Fragment} from 'react';
import {I18n, Translate} from 'react-redux-i18n';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import {get, set, toInteger, debounce, merge, forEach, isEmpty, isEqual, cloneDeep, has} from 'lodash';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import moment from 'moment';

import DefaultConfirmationDialog from '../../../components/DefaultConfirmationDialog';
import {save as saveSettings, updateDBE as saveDBEPolicy} from '../SettingsActions';
import {loadOerTypes, loadGroups, loadTerminals} from '../../../LibraryFilter/libraryFilterActions';
import getSettings from '../../../actions/customer';
import OerCheckbox from '../../../components/OerTriggerCheckbox';
import OverPostedSpeedTooltip from '../component/OverPostedSpeedTooltip';
import Checkbox from '../../../components/form/Checkbox';
import IconBox from '../component/IconBox';
import AndroidIcon from '../../../images/mrrobot-icon.svg';
import DVRToolkitPasswordSection from '../sections/DVRToolkitPasswordSection';
import OnDemandIcon from '../../../images/ondemand-grey-icon.svg';
import formatOERLabel from '../../../util/formatOERLabel';

const DEFAULT_SD_CARD_RETENTION_DAYS = 7;
const MAX_DATA_RETENTION_DAYS = 365;
const sharedYcEvents = ['yc_engine_control','yc_brake_control'];
const sharedHardCorneringEvents = ['rop_engine_control','rop_brake_control','hard_cornering'];
const sharedHardCorneringGeotab = ['ruleharshcorneringid', 'hard_cornering'];
const sharedSuddenStop = ['sudden_stop', 'harsh_braking'];
const sharedSuddenStopGeotab = ['ruleHarshbrakingid', 'harsh_braking'];
const sharedSuddenStart = ['sudden_start', 'aggressive_acceleration'];
const sharedSuddenStartGeotab = ['rulejackrabbitstartsid', 'aggressive_acceleration'];
const DRIVER_BEHAVIOR_EVENTS = ['fatigue', 'cellphone_usage', 'driver_distraction', 'driver_smoking', 'seat_belt_usage'];
class Settings extends React.Component {
  systemBlurringSettings = null;
  customerBlurringSettings = null;
  constructor(props) {
    super(props);
    let blurring = cloneDeep(get(props, 'data.blurring_v2', {}));
    /**
     * Initialized blurring value based on customer / system level settings
     * If customer settings is null, then we will set the system level settings
     * This will be used to disable or enable the checkbox and set it as selected based on the blurring value
     */
    this.systemBlurringSettings = get(props.system, 'settings.blurring', false);
    this.customerBlurringSettings = get(props.data, 'blurring_v2.enabled', null);
    if (this.customerBlurringSettings === null) {
      blurring = {enabled: this.systemBlurringSettings};
    }
    this.state = {
      settings: get(props, 'data.settings', {}),
      intelliview: get(props, 'data.intelliview', {}),
      blurring: blurring,
      dataRetention: {
        current: cloneDeep(get(props, 'data.dataRetention', {})),
        previous: cloneDeep(get(props, 'data.dataRetention', {}))
      },
      dataRetentionWarning: false,
      sdCardRetention: {
        current: cloneDeep(get(props, 'data.sdCardRetention_v2', null)),
        previous: cloneDeep(get(props, 'data.sdCardRetention_v2', null)),
        checkMaxStorage: {enabled: false},
        maxStorageInDays: {value: DEFAULT_SD_CARD_RETENTION_DAYS}
      },
      settingsValid: {
        excessiveOverSpeed: true,
        overSpeed: true,
        exceededMaxDbRetention: false,
        validDbRetention: true,
        sdCardRetentionMaxDaysValid: true
      },
      validation: {
        ok: true,
        errors: {}
      },
      uncheckTriggerDialogOpened: false,
      uncheckOerDialogOpened: false,
      changeDbRetentionDialogOpened: false,
      oerId: null,
      isSaving: false,
      isSaved: false,
      tabIndex: 0,
      userInfo: null,
      driverBehavior: {
        enabled: get(props, 'data.driverBehavior.enabled', false),
        changedBy: get(props, 'data.driverBehavior.changedBy', null),
        enabledAt: get(props, 'data.driverBehavior.enabledAt', null),
        remoteIP: get(props, 'data.driverBehavior.remoteIP', null)
      }
    };
  }

  componentDidMount = () => {
    this.props.getSettings(true);
    this.props.loadOerTypes({showAll: true});
    const {sdCardRetention} = this.state;
    this.setState({
      sdCardRetention: {
        ...sdCardRetention,
        checkMaxStorage: {enabled: (sdCardRetention.current === null)},
        maxStorageInDays: {value: (sdCardRetention.current === null) ? DEFAULT_SD_CARD_RETENTION_DAYS : sdCardRetention.current.value}
      }
    })
  }

  checkAndUpdateState = (newProps, stateIdentifier) => {
    const propsData = get(this.props, `data.${stateIdentifier}`, {});
    const newPropsData = get(newProps, `data.${stateIdentifier}`, {});
    if(JSON.stringify(propsData) !== JSON.stringify(newPropsData)){
      switch(stateIdentifier){
        case 'dataRetention':
          this.setState({dataRetention:{
              current: cloneDeep(newPropsData),
              previous: cloneDeep(newPropsData)
            }})
          break;
        case 'sdCardRetention_v2':
          this.setState({sdCardRetention: {
              current: {...newPropsData},
              previous: {...newPropsData},
              checkMaxStorage: {enabled: (newPropsData === null)},
              maxStorageInDays: {value: (newPropsData === null) ? DEFAULT_SD_CARD_RETENTION_DAYS : newPropsData.value}
            }})
          break;
        case 'blurring_v2':
          this.customerBlurringSettings = newPropsData?.enabled;
          this.setState({blurring: {...newPropsData}})
          break;
        default:
          this.setState({[stateIdentifier]: newPropsData})
          break;
      }
    }
  }

  componentWillReceiveProps(newProps) {
    ['settings', 'blurring_v2', 'dataRetention', 'sdCardRetention_v2'].forEach((key)=>{
      this.checkAndUpdateState(newProps, key);
    })

    if (this.props.saving && !newProps.saving) {
      setTimeout(() => this.setState({isSaving: newProps.saving, isSaved: newProps.saved, dataRetentionWarning: false}), 450);
    }
    if (!this.props.saving && newProps.saving) {
      this.setState({isSaving: newProps.saving, isSaved: false});
    }
  }

  setSharedEvents = (oer, systemId, settings, value, list) => {
    switch (oer) {
      case 'hard_cornering':
        if (systemId === 'peoplenet') {
         sharedHardCorneringEvents.forEach( event => {
            set(settings, `${list}.${event}`, value);
          });
        }
        if (systemId === 'geotab') {
          sharedHardCorneringGeotab.forEach( event => {
            set(settings, `${list}.${event}`, value);
          });
        }
        set(settings, `${list}.${oer}`, value);
        break;

      case 'sudden_stop':
        if (systemId === 'peoplenet') {
          sharedSuddenStop.forEach( event => {
            set(settings, `${list}.${event}`, value);
          });
        }
        if (systemId === 'geotab') {
          sharedSuddenStopGeotab.forEach( event => {
            set(settings, `${list}.${event}`, value);
          });
        }
        set(settings, `${list}.${oer}`, value);
        break;

      case 'sudden_start':
        if (systemId === 'peoplenet') {
          sharedSuddenStart.forEach( event => {
            set(settings, `${list}.${event}`, value);
          });
        }

        if (systemId === 'geotab') {
          sharedSuddenStartGeotab.forEach( event => {
            set(settings, `${list}.${event}`, value);
          });
        }
        set(settings, `${list}.${oer}`, value);
        break;

      case 'yc_event':
        if (systemId === 'peoplenet') {
          sharedYcEvents.forEach(event => set(settings, `${list}.${event}`, value));
        }
        set(settings, `${list}.${oer}`, value);
        break;
      default:
        set(settings, `${list}.${oer}`, value);
        break;
    }
    this.setState({ settings });
  }

  handlerOerChange = (oer, ev, value) => {
    const { settings } = this.state;
    const { system } = this.props;

    const systemId = localStorage.getItem('systemId');

    if(system.settings == null){
      set(system, `settings.systemId`, '');
    }

    this.setSharedEvents(oer.id, systemId ? systemId : system.settings.systemId, settings, value, 'oerList');
  }

  handleOerTriggerChange = (oer, value) => {
    const { settings } = this.state;
    const { system } = this.props;

    const systemId = localStorage.getItem('systemId');

    if(system.settings == null){
      set(system, `settings.systemId`, '');
    }

    this.setSharedEvents(oer.id, systemId ? systemId : system.settings.systemId, settings, value, 'triggerOER');
  }

  handleChangeSpeed = field => ({target}) => {
    const {value} = target;
    const {settings} = this.state;
    set(settings, field, value);
    this.setState({settings}, this.validateForm);
  }

  handleBlurSpeed = field => ({target}) => {
    const {value} = target;
    const {settings} = this.state;
    set(settings, field, toInteger(value));
    this.setState({settings}, this.validateForm);
  }

  handleDbRetentionChange = field => ({target}) => {
    const {value} = target;
    const {dataRetention} = this.state;
    set(dataRetention, 'current.value', toInteger(value));
    this.setState({dataRetention}, this.validateForm);
  }

  handleBlurDbRetention = field => ({target}) => {
    const {dataRetention} = this.state;
    let showDbRetentionChangeDialog = ((dataRetention.current.value <= MAX_DATA_RETENTION_DAYS && dataRetention.current.value > 0) && (dataRetention.current.value !== dataRetention.previous.value));
    this.setState({changeDbRetentionDialogOpened: showDbRetentionChangeDialog, dataRetentionWarning: (dataRetention.current.value !== dataRetention.previous.value)})
  }

  handleChangeTerminal = (ev, value) => {
    const {settings} = this.state;
    set(settings, 'useTerminal', value);
    this.setState({settings}, this.validateForm);
  }

  handleBlurringChange = (ev, value) => {
    const {blurring} = this.state;
    set(blurring, 'enabled', value);
    this.setState({blurring});
  }

  handleSdCardStorageChange = (ev, value) => {
    const {sdCardRetention} = this.state;
    set(sdCardRetention, 'checkMaxStorage.enabled', value);
    if(value === true){
      set(sdCardRetention, 'current', null);
      set(sdCardRetention, 'maxStorageInDays.value', DEFAULT_SD_CARD_RETENTION_DAYS);
    }
    this.setState({sdCardRetention}, this.validateForm);
  }

  handleTriggernWarning = (oer, ev, value) => {
    if (value) {
      this.handleOerTriggerChange(oer, true);
      return;
    }

    this.setState({uncheckTriggerDialogOpened: true, oerId: oer.id});
  }

  handleUncheckTriggerConfirmation = () => {
    this.handleOerTriggerChange({id: this.state.oerId}, false);
    this.setState({uncheckTriggerDialogOpened: false, oerId: null});
  }

  closeUncheckTriggerConfirmation = () => {
    this.setState({uncheckTriggerDialogOpened: false, oerId: null});
  }

  handleDbRetentionConfirmation = () => {
    this.setState({changeDbRetentionDialogOpened: false, dataRetentionWarning: true});
  }

  closeDbRetentionConfirmation = () => {
    const {dataRetention} = this.state;
    set(dataRetention, 'current.value', dataRetention.previous.value);
    this.setState({dataRetention, changeDbRetentionDialogOpened: false, dataRetentionWarning: (dataRetention.current.value !== dataRetention.previous.value)});
  }

  handleChangeScoring = (ev, value) => {
    const {settings} = this.state;
    set(settings, 'scoring', value);
    this.setState({settings}, this.validateForm);
  }

  handleChangeGPSSpeed = (ev, value) => {
    const {settings} = this.state;
    set(settings, 'gpsSpeed', value);
    this.setState({settings}, this.validateForm);
  }

  handleMaxStorageChange = (ev, value) => {
    const {sdCardRetention} = this.state;
    set(sdCardRetention, 'maxStorageInDays.value', toInteger(ev.target.value));
    set(sdCardRetention, 'current.value', toInteger(ev.target.value));
    this.setState({sdCardRetention}, this.validateForm);
  }

  handleChangeBlinker = (ev, value) => {
    const {settings} = this.state;
    set(settings, 'blinker', value);
    this.setState({settings});
  }

  validateForm = () => {
    const {settings, settingsValid, dataRetention, sdCardRetention} = this.state;
    settingsValid.overSpeed = true;
    settingsValid.excessiveOverSpeed = true;
    settingsValid.exceededMaxDbRetention = false;
    settingsValid.validDbRetention = true;
    settingsValid.sdCardRetentionMaxDaysValid = true;

    if (settings.overSpeed < 0) {
      settingsValid.overSpeed = false;
    }

    if (settings.excessiveOverSpeed !== 0 && !(settings.excessiveOverSpeed > settings.overSpeed)) {
      settingsValid.excessiveOverSpeed = false;
    }

    if(dataRetention.current.value > MAX_DATA_RETENTION_DAYS){
      settingsValid.exceededMaxDbRetention = true;
    }

    if(dataRetention.current.value <= 0){
      settingsValid.validDbRetention = false;
    }

    if(!sdCardRetention.checkMaxStorage.enabled && sdCardRetention.maxStorageInDays.value > 31){
      settingsValid.sdCardRetentionMaxDaysValid = false;
    }

    this.setState({settingsValid});
  }

  handleSecondaryVideoType = item => () => {
    const {intelliview} = this.state;
    const secondaryVideos = [...(intelliview.secondaryVideos || [])];
    const itemIndex = secondaryVideos.indexOf(item);
    if (itemIndex === -1) {
      secondaryVideos.push(item);
      this.setState({
        intelliview: {
          ...this.state.intelliview,
          secondaryVideos
        }
      });
    } else {
      this.setState({
        intelliview: {
          ...this.state.intelliview,
          secondaryVideos: secondaryVideos.filter((el, index) => index !== itemIndex)
        }
      });
    }
  }

  handleEventType = item => () => {
    const {intelliview} = this.state;
    const eventTypes = [...(intelliview.eventTypes || [])];
    const itemIndex = eventTypes.indexOf(item);
    if (itemIndex === -1) {
      eventTypes.push(item);
      this.setState({
        intelliview: {
          ...this.state.intelliview,
          eventTypes
        }
      });
    } else {
      this.setState({
        intelliview: {
          ...this.state.intelliview,
          eventTypes: eventTypes.filter((el, index) => index !== itemIndex)
        }
      });
    }
  };

  handleSettingsChange = debounce((changedSettings, validation) => {
    this.checkValidation(validation);

    if (!changedSettings) {
      return;
    }

    const newSettings = merge({}, this.state.settings, changedSettings);

    this.setState({
      settings: newSettings
    });
  }, 200)

  checkValidation = validation => {
    if (!validation) {
      return;
    }

    const errors = {
      ...this.state.validation.errors
    };

    forEach(validation.errors, (hasError, key) => {
      if (hasError) {
        errors[key] = hasError;
      } else if (errors[key]) {
        delete errors[key];
      }
    });

    this.setState({
      validation: {
        ok: isEmpty(errors),
        errors
      }
    });
  }

  checkIfSettingsUpdated = (propsKey, formValue) => {
    let propsValue = get(this.props, `data.${propsKey}`, {});
    return !isEqual(propsValue,formValue);
  }

  handleSave = () => {
    const {settings, intelliview, blurring, dataRetention, sdCardRetention} = this.state;
    const {userInfo} = this.props;

    let isInternal = false;
    let changeCustomerRole = false;
    let videoIntelligenceInternal = false;
    if(has(userInfo, 'roles')){
      const userRoles = get(userInfo, 'roles', null);
      changeCustomerRole = get(userRoles, 'changeCustomer', false);
      videoIntelligenceInternal = get(userRoles, 'videoIntelligenceInternal', false);
    }
    changeCustomerRole = (has(userInfo, 'changeCustomer'))?get(userInfo, 'changeCustomer', false):changeCustomerRole;
    isInternal = (changeCustomerRole || videoIntelligenceInternal);

    delete settings.settings;
    settings.overSpeed = toInteger(settings.overSpeed);
    settings.excessiveOverSpeed = toInteger(settings.excessiveOverSpeed);

    let sdCardRetentionValue = (!sdCardRetention.checkMaxStorage.enabled) ? sdCardRetention.maxStorageInDays : null;
    let desiredStateData = {sdCardRetentionDays: sdCardRetention.maxStorageInDays.value, allowMaxDays: sdCardRetention.checkMaxStorage.enabled};
    let publishSDCardRetentionChange = JSON.stringify(get(sdCardRetention, 'current.value', null)) !== JSON.stringify(get(sdCardRetention, 'previous.value', null));
    desiredStateData = (publishSDCardRetentionChange) ? desiredStateData : null;

    let formFieldValues = {'blurring_v2': blurring, 'intelliview': intelliview, 'dataRetention': dataRetention.current, 'sdCardRetention_v2': sdCardRetentionValue };
    let postData = {settings, userId: userInfo.userId, userName: userInfo.userName, userEmail: userInfo.email, isInternal};

    let payloadData = {settings, intelliview, blurring_v2: blurring, dataRetention: dataRetention.current, sdCardRetention_v2: sdCardRetentionValue};
    ['blurring_v2', 'intelliview', 'dataRetention', 'sdCardRetention_v2'].forEach((key)=>{
      if(this.checkIfSettingsUpdated(key, formFieldValues[key])){
        postData[key] = formFieldValues[key];
      }
    });
    this.props.saveSettings(postData, desiredStateData, payloadData);
  }

  handleChangeTabIndex = index => {
    this.setState({tabIndex: index});
  }

  handleChangeTab = (event, value) => {
    this.setState({tabIndex: value});
  };

  handleSortingTranslatedEvents(eventsArr) {
    const mappedEvents = eventsArr.map(event => {
      return {
        id: event,
        translatedEvent: formatOERLabel(event)
      }
    }).sort((a, b) => (a.translatedEvent > b.translatedEvent) ? 1 : -1);

    return mappedEvents.map(event => event.id);
  };

  checkEnabledEvents = (list, item, systemId) => {
    const sharedEvents = [];
    switch (item) {
      case 'hard_cornering':
        if (systemId === 'peoplenet') {
          sharedEvents.push(...sharedHardCorneringEvents);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }
        if (systemId === 'geotab') {
          sharedEvents.push(...sharedHardCorneringGeotab);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }
        return get(list, item, true) === true;

      case 'sudden_stop':
        if (systemId === 'peoplenet') {
          sharedEvents.push(...sharedSuddenStop);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }
        if (systemId === 'geotab') {
          sharedEvents.push(...sharedSuddenStopGeotab);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }
        return get(list, item, true) === true;

      case 'sudden_start':
        if (systemId === 'peoplenet') {
          sharedEvents.push(...sharedSuddenStart);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }

        if (systemId === 'geotab') {
          sharedEvents.push(...sharedSuddenStartGeotab);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }
        return get(list, item, true) === true;

      case 'yc_event':
        if (systemId === 'peoplenet') {
          sharedEvents.push(...sharedYcEvents);
          return this.handleSharedEventsChecked(list, sharedEvents);
        }
        return get(list, item, true) === true;

      default:
        if (DRIVER_BEHAVIOR_EVENTS.includes(item)) {
          if (this.state.driverBehavior.enabled === false) {
            return false;
          }

          return get(list, item, false) === true;
        }

        return get(list, item, true) === true;
    }
  }

  handleSharedEventsChecked = (list, arrToBeChecked) => {
    if (!this.hasAnySharedEvents(list, arrToBeChecked)) {
      return true;
    }

    const result = [];
    for (const [key, value] of Object.entries(list)) {
      if (arrToBeChecked.includes(key)) {
        result.push(value);
      }
    }

    return result.some(item => item);
  }

  hasAnySharedEvents = (list, sharedEvArr) => {
    let a = false;
    for(const event of sharedEvArr) {
      if (list.hasOwnProperty(event)) {
        a = true;
        break;
      }
    }
    return a;
  }

  getDriverBehaviorEnabled = () => {
    const driverBehaviorData = this.state.driverBehavior;
    const humanReadableEnabledAt = moment(driverBehaviorData.enabledAt).format(I18n.t('configuration.fullDateTimeFormat'));
    return (
      <div className='admin__driverBehaviorEnabled'>
        <span>
          <Translate
            value='page.admin.form.driverBehaviorEnabled'
            dangerousHTML
          />
        </span>
        <span>
          <Translate
            value='page.admin.form.driverBehaviorChangedBy'
            dangerousHTML
            changedBy={driverBehaviorData.changedBy}
            enabledAt={humanReadableEnabledAt}
          />
        </span>
        <Button
          variant="contained"
          className="btn btn-primary admin__btnUpdateDBE admin__disableColor"
          onClick={() => this.handleDBE(false)}
        >
          {/* {isSaving && (<CircularProgress className="btn__loading btn__loading-primary  btn__floatingcirc" />) */}
          {false && (<CircularProgress className="btn__loading btn__loading-primary  btn__floatingcirc" />)
          }
          {I18n.t('page.admin.form.buttonDBE.disable')}
        </Button>
      </div>
    );
  }

  getDriverBehaviorDisabled = () => {
    return (
      <div>
        <span>
          {I18n.t('page.admin.form.driverBehaviorLegal1')}
        </span>
        <span>
          {I18n.t('page.admin.form.driverBehaviorLegal2')}
        </span>
        <span className='admin__driverBehaviorDisabled'>
          <Translate
            value='page.admin.form.driverBehaviorDisabled'
            dangerousHTML
          />
        </span>
        <Button
          variant="contained"
          className="btn btn-primary admin__btnUpdateDBE"
          onClick={() => this.handleDBE(true)}
        >
          {/* {isSaving && (<CircularProgress className="btn__loading btn__loading-primary  btn__floatingcirc" />) */}
          {false && (<CircularProgress className="btn__loading btn__loading-primary  btn__floatingcirc" />)
          }
          {I18n.t('page.admin.form.buttonDBE.enable')}
        </Button>
      </div>
    );
  }

  handleDBE = async (enabled) => {
    const {email, userId, userName} = this.props.userInfo;
    const driverBehaviorData = await this.props.saveDBEPolicy({
      enabled,
      userId,
      userEmail: email,
      changedBy: userName
    });

    const humanReadableEnabledAt = moment(get(driverBehaviorData, 'enabledAt', null)).format(I18n.t('configuration.fullDateTimeFormat'));

    this.setState({
      driverBehavior: {
        enabled: get(driverBehaviorData, 'enabled', false),
        changedBy: get(driverBehaviorData, 'changedBy', null),
        enabledAt: humanReadableEnabledAt,
        remoteIP: get(driverBehaviorData, 'remoteIP', null)
      }
    });

    /* Force update on props so the data could be consistent whenever changing pages */
    this.props.data.driverBehavior = {
      enabled: get(driverBehaviorData, 'enabled', false),
      changedBy: get(driverBehaviorData, 'changedBy', null),
      enabledAt: humanReadableEnabledAt,
      remoteIP: get(driverBehaviorData, 'remoteIP', null)
    };
  }

  checkDisabledDBE = (item) => {
    if (DRIVER_BEHAVIOR_EVENTS.includes(item)) {
      return this.state.driverBehavior.enabled ? false : true;
    }

    return false;
  }

  render() {
    const {
      loading,
      system,
      data: customer
    } = this.props;

    const {
      settings,
      settingsValid,
      validation,
      isSaving,
      isSaved,
      intelliview,
      blurring,
      dataRetention,
      dataRetentionWarning,
      sdCardRetention
    } = this.state;

    let {oerList, triggerOER} = settings;
    const isEventTypeChecked = item => intelliview.eventTypes && intelliview.eventTypes.indexOf(item) !== -1;
    const isSecondaryVideoChecked = item => intelliview.secondaryVideos && intelliview.secondaryVideos.indexOf(item) !== -1;
    const iconsOpacity = intelliview && intelliview.enabled ? 1 : 0.2;
    const isInteliviewDisabled = !intelliview || !intelliview.enabled;
    const isBlurringDisabled = !this.customerBlurringSettings && !this.systemBlurringSettings;
    let systemId = localStorage.getItem('systemId');

    if(system.settings == null){
      set(system, `settings.systemId`, '');
    }

    if (!oerList) {
      oerList = {};
    }

    if (!triggerOER) {
      triggerOER = {};
    }

    const engineTriggers = [];
    if (systemId === 'geotab') {
      engineTriggers.push(...[
        'collision_mitigation',
        'ruleHarshbrakingid',
        'rulejackrabbitstartsid',
        'ruleharshcorneringid',
        'ruleaccidentid',
      ]);
    }

    if (system.settings.systemId === 'ttl') {
      engineTriggers.push(...[
        'ptoAlarm',
        'ptoStart',
        'ptoEnd',
        'navigationDestReached',
        'speedingLimitStart',
        'peekRPMStart',
        'maximumAcceleration',
        'maximumDeceleration',
        'stationaryTime',
        'enterGeofence',
        'exitGeofence',
        'speedingLimitUpdate',
        'peekRPMUpdate',
        'serviceCoupureWarning',
        'sensorViolation',
        'weightUpdate',
        'rollViolation',
        'pitchViolation',
        'rollAlarm',
        'pitchAlarm',
        'fuelLevelIncreaseStart',
        'fuelLevelDecreaseStart',
        'alarmProfile',
        'alarmProfileTotal',
        'aggressive_acceleration',
        'harsh_braking',
        'hard_cornering',
      ]);
    }

    if (system.settings.systemId === 'peoplenet') {
      engineTriggers.push(...[
        'stability_control_7',
        'headway',
        'collision_mitigation',
        'meritor_onguard_collision_mitigation',
        'manual',
        'panic',
        'sudden_stop',
        'sudden_start',
        'hard_cornering',
        'yc_event'
      ]);
    }

    if (system.settings.systemId === 'togs') {
      engineTriggers.push(...[
        'distress',
        'oot_session_expired',
        'impact_detected',
        'aggressive_acceleration',
        'harsh_braking',
        'hard_cornering',
        'excessive_speeding'
      ]);
    }

    let showDvrEvents = false;
    if (customer.dvrEvents || (customer.dvrEvents === undefined && system.settings.dvrEvents)) {
      showDvrEvents = true;
    }

    const cimEvents = [];
    const DBE = [];
    if (showDvrEvents || systemId === 'geotab') {
      engineTriggers.push(...[
        'lane_departure',
        'frontal_collision_prediction',
        'excessive_speed',
        'forward_collision_warning',
        'headway_monitoring',
      ]);
      cimEvents.push(...[
        'camera_blocked',
      ]);

      DBE.push(...DRIVER_BEHAVIOR_EVENTS);
    }
    let allEventsSortedById = this.handleSortingTranslatedEvents(engineTriggers);
    const driverBehaviorEventsSortedById = this.handleSortingTranslatedEvents(DBE);

    if (cimEvents.length > 0){
      allEventsSortedById.push(...this.handleSortingTranslatedEvents(cimEvents));
    }

    const videoEvents = [];
    videoEvents.push(
      <Grid container className="noScroll" spacing={0}>
        <Grid item xs={12}>
          <Grid container spacing={0} justify="center">
            <Grid item xs={12} className="admin__container_videoevents-header admin__container_videoevents-header__label">
              <span>Event List</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={0} justify="center" className="admin__container_icons-header">
            <Grid item xs={1} className="admin__checkbox_icons-header">
              <img src={OnDemandIcon} alt="icon" className="admin__icon_size" />
            </Grid>
            <Grid item xs={11} className="admin__header-charticon">
              <Icon className="admin__charticon">insert_chart</Icon>
            </Grid>
          </Grid>
        </Grid>
        {allEventsSortedById.map(item => ({ id: item })).map(item => {
          return (
            <OerCheckbox
              key={item.id}
              oer={item}
              oerChecked={this.checkEnabledEvents(oerList, item.id, systemId ? systemId : system.settings.systemId)}
              triggerChecked={this.checkEnabledEvents(triggerOER, item.id, systemId ? systemId : system.settings.systemId)}
              handleOerChange={this.handlerOerChange}
              handleOerTriggerChange={this.handleTriggernWarning}
              systemId={systemId ? systemId : system.settings.systemId}
            />
          );
        })}
      </Grid>
    );

    const driverBehaviorEvents = [];
    driverBehaviorEvents.push(
      <Grid container className="noScroll" spacing={0}>
        <Grid item xs={12}>
          <Grid container spacing={0} justify="center">
            <Grid item xs={12} className="admin__container_videoevents-header admin__container_videoevents-header__label">
              <span>Event List</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={0} justify="center" className="admin__container_icons-header">
            <Grid item xs={1} className="admin__checkbox_icons-header">
              <img src={OnDemandIcon} alt="icon" className="admin__icon_size" />
            </Grid>
            <Grid item xs={11} className="admin__header-charticon">
              <Icon className="admin__charticon">insert_chart</Icon>
            </Grid>
          </Grid>
        </Grid>
        {driverBehaviorEventsSortedById.map(item => ({ id: item })).map(item => {
          return (
            <OerCheckbox
              key={item.id}
              oer={item}
              oerChecked={this.checkEnabledEvents(oerList, item.id, systemId ? systemId : system.settings.systemId)}
              triggerChecked={this.checkEnabledEvents(triggerOER, item.id, systemId ? systemId : system.settings.systemId)}
              oerDisabled={this.checkDisabledDBE(item.id)}
              triggerDisabled={this.checkDisabledDBE(item.id)}
              handleOerChange={this.handlerOerChange}
              handleOerTriggerChange={this.handleTriggernWarning}
              systemId={systemId ? systemId : system.settings.systemId}
            />
          );
        })}
      </Grid>
      );

    return (
        <React.Fragment>
          <DefaultConfirmationDialog
              open={this.state.uncheckTriggerDialogOpened}
              title={I18n.t('page.admin.form.disableEventType.confirmationDialog.title')}
              message={I18n.t('page.admin.form.disableEventType.confirmationDialog.message')}
              onClose={this.closeUncheckTriggerConfirmation}
              onConfirm={this.handleUncheckTriggerConfirmation}
          />
          <DefaultConfirmationDialog
              open={this.state.uncheckOerDialogOpened}
              title={I18n.t('page.admin.form.disableEventType.confirmationDialog.title')}
              message={I18n.t('page.admin.form.disableEventType.confirmationDialog.message')}
              onClose={this.closeUncheckOerConfirmation}
              onConfirm={this.handleUncheckOerConfirmation}
          />
          <DefaultConfirmationDialog
              open={this.state.changeDbRetentionDialogOpened}
              title={I18n.t('page.admin.form.videoRetention.confirmationDialog.title')}
              message={<Translate
                  value="page.admin.form.videoRetention.confirmationDialog.message"
                  dangerousHTML
                  previous={(dataRetention.previous.value === null ? 0 : dataRetention.previous.value)}
                  current={(dataRetention.current.value === null ? 0 : dataRetention.current.value)}
              />}
              onClose={this.closeDbRetentionConfirmation}
              onConfirm={this.handleDbRetentionConfirmation}
              hasButton={true}
              buttonDefaultYes={I18n.t('page.admin.form.videoRetention.confirmationDialog.submit')}
              buttonDefaultNo={I18n.t('page.admin.form.videoRetention.confirmationDialog.cancel')}
              hasTextConfirm={true}
              confirmText={I18n.t('page.admin.form.videoRetention.confirmationDialog.confirmText')}
          />

          <Grid container className="admin noScroll">
            {loading &&
                <div className="dvrcard__progresscont">
                  <CircularProgress className="loading__cirgularprogress" size={50} />
                </div>
            }
            {!loading &&
                <Grid item lg={7} md={10} sm={12} xs={12}>
                  <ExpansionPanel defaultExpanded id="panel1">
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h3">{I18n.t('page.admin.form.videoEvents')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{padding: 0}}>
                      <div>
                          {videoEvents}
                        <div className="admin__info-cont">
                          <Icon className="admin__info-icon admin__info-icon-top" style={{transform: 'translateY(12px)'}}>info</Icon>
                          <div className="admin__multimessages-cont">
                        <span>
                          {`${I18n.t('page.admin.form.intelliviewType.infoMessagePrefix')}`} <img src={OnDemandIcon} style={{transform: 'translateY(12px)', marginLeft:-1}} className="admin__icon_size" />{I18n.t('page.admin.form.hideEventTriggerHelp')}
                        </span>
                            <span>
                          {`${I18n.t('page.admin.form.intelliviewType.infoMessagePrefix')}`} <Icon
                                style={{
                                  marginLeft: 0, marginRight: 0, transform: 'translateY(5px)', color: '#767676'
                                }}
                            >insert_chart
                          </Icon> {I18n.t('page.admin.form.hideEventTypesHelp')}
                        </span>
                          </div>
                        </div>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel id="panel2">
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h3">{I18n.t('page.admin.form.driverBehaviorEvents')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{padding: 0, flexDirection: 'column'}}>
                      <div className='admin__driverBehaviorLegal'>
                        {this.state.driverBehavior.enabled ? this.getDriverBehaviorEnabled() : this.getDriverBehaviorDisabled()}
                      </div>
                      <div>
                          {driverBehaviorEvents}
                        <div className="admin__info-cont">
                          <Icon className="admin__info-icon admin__info-icon-top" style={{transform: 'translateY(12px)'}}>info</Icon>
                          <div className="admin__multimessages-cont">
                        <span>
                          {`${I18n.t('page.admin.form.intelliviewType.infoMessagePrefix')}`} <img src={OnDemandIcon} style={{transform: 'translateY(12px)', marginLeft:-1}} className="admin__icon_size" />{I18n.t('page.admin.form.hideEventTriggerHelp')}
                        </span>
                            <span>
                          {`${I18n.t('page.admin.form.intelliviewType.infoMessagePrefix')}`} <Icon
                                style={{
                                  marginLeft: 0, marginRight: 0, transform: 'translateY(5px)', color: '#767676'
                                }}
                            >insert_chart
                          </Icon> {I18n.t('page.admin.form.hideEventTypesHelp')}
                        </span>
                          </div>
                        </div>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  {<ExpansionPanel id="panel7">
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h3">{I18n.t('page.admin.form.dataPrivacy.title')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className="admin__checkbox-cont">
                        <Grid container spacing={0}>
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <Grid
                                  item
                                  xs={12}
                              >
                                <div>
                                  <Checkbox
                                      id="ck_event_blurring"
                                      className="admin__event_blurring"
                                      label={I18n.t('page.admin.form.blurring.title')}
                                      onChange={this.handleBlurringChange}
                                      checked={blurring && blurring.enabled}
                                      disabled={isBlurringDisabled}
                                  />
                                  <div className="admin__info-cont" style={{paddingLeft: 0}}>
                                    <Icon className="admin__info-icon admin__info-icon-top">info</Icon>
                                    <div className="admin__multimessages-cont">
                                      <span>
                                        {`${I18n.t('page.admin.form.dataPrivacy.blurringInfo')}`}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        { isBlurringDisabled && <div className="admin__info-cont" style={{paddingLeft: 0}}>
                          <Icon className="admin__info-icon admin__info-icon-top">info</Icon>
                          <div className="admin__multimessages-cont">
                              <div style={{color: '#C4212A'}}>
                                {I18n.t('page.admin.form.blurring.inactiveMessage')}
                              </div>
                          </div>
                        </div>}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  }
                  <ExpansionPanel id="panel6">
                    <ExpansionPanelSummary id="intelliview_panel" expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h3">{I18n.t('page.admin.form.intelliviewType.title')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className="admin__checkbox-cont">
                        <Grid container spacing={0}>
                          <Grid item xs={6}>
                            <Grid container justify="center" className="admin__checkbox">
                              <Grid item xs={1}>
                                <IconBox type="robot" opacity={iconsOpacity} />
                                <div>
                                  <Checkbox
                                      id="ck_event_collision_mitigation"
                                      className="admin__event_collision_mitigation"
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleEventType('collision_mitigation')}
                                      checked={isEventTypeChecked('collision_mitigation')}
                                  />
                                </div>
                              </Grid>
                              <Grid
                                  item
                                  xs={11}
                              >
                                <IconBox type="eye" opacity={iconsOpacity} className="admin__eyeicon" />
                                <div>
                                  <Checkbox
                                      id="ck_secondary_collision_mitigation"
                                      className="admin__secondary_collision_mitigation"
                                      label={I18n.t('page.admin.form.intelliviewType.collisionMitigation')}
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleSecondaryVideoType('collision_mitigation')}
                                      checked={isSecondaryVideoChecked('collision_mitigation')}
                                  />
                                </div>
                              </Grid>
                            </Grid>
                            <Grid container justify="center" className="admin__checkbox">
                              <Grid item xs={1}>
                                <div>
                                  <Checkbox
                                      id="ck_event_meritor_onguard_collision_mitigation"
                                      className="admin__event_meritor_onguard_collision_mitigation"
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleEventType('meritor_onguard_collision_mitigation')}
                                      checked={isEventTypeChecked('meritor_onguard_collision_mitigation')}
                                  />
                                </div>
                              </Grid>
                              <Grid
                                  item
                                  xs={11}
                              >
                                <div>
                                  <Checkbox
                                      id="ck_secondary_meritor_onguard_collision_mitigation"
                                      className="admin__secondary_meritor_onguard_collision_mitigation"
                                      label={I18n.t('page.admin.form.intelliviewType.meritorOnguardCollisionMitigation')}
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleSecondaryVideoType('meritor_onguard_collision_mitigation')}
                                      checked={isSecondaryVideoChecked('meritor_onguard_collision_mitigation')}
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={6}>
                            <Grid container justify="center" className="admin__checkbox">
                              <Grid item xs={1}>
                                <IconBox type="robot" opacity={iconsOpacity} />
                                <div>
                                  <Checkbox
                                      id="ck_event_headway"
                                      className="admin__event_headway"
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleEventType('headway')}
                                      checked={isEventTypeChecked('headway')}
                                  />
                                </div>
                              </Grid>
                              <Grid
                                  item
                                  xs={11}
                              >
                                <IconBox type="eye" opacity={iconsOpacity} />
                                <div>
                                  <Checkbox
                                      id="ck_secondary_headway"
                                      className="admin__secondary_headway"
                                      label={I18n.t('page.admin.form.intelliviewType.headway')}
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleSecondaryVideoType('headway')}
                                      checked={isSecondaryVideoChecked('headway')}
                                  />
                                </div>
                              </Grid>
                            </Grid>
                            <Grid container justify="center" className="admin__checkbox">
                              <Grid item xs={1}>
                                <div>
                                  <Checkbox
                                      id="ck_event_stability_control_7"
                                      className="admin__event_stability_control_7"
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleEventType('stability_control_7')}
                                      checked={isEventTypeChecked('stability_control_7')}
                                  />
                                </div>
                              </Grid>
                              <Grid
                                  item
                                  xs={11}
                              >
                                <div>
                                  <Checkbox
                                      id="ck_secondary_stability_control_7"
                                      className="admin__secondary_stability_control_7"
                                      label={I18n.t('page.admin.form.intelliviewType.forwardCollisionWarning')}
                                      disabled={isInteliviewDisabled}
                                      onChange={this.handleSecondaryVideoType('stability_control_7')}
                                      checked={isSecondaryVideoChecked('stability_control_7')}
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <div className="admin__info-cont">
                          <Icon className="admin__info-icon admin__info-icon-top">info</Icon>
                          <div className="admin__multimessages-cont">
                            { !isInteliviewDisabled && (
                                <Fragment>
                            <span>
                              {`${I18n.t('page.admin.form.intelliviewType.infoMessagePrefix')}`} <img src={AndroidIcon} style={{marginLeft: 4, marginRight: 4, transform: 'translateY(2px)'}} /> {I18n.t('page.admin.form.intelliviewType.eventTypeSufixMessage')}
                            </span>
                                  <span>
                              {`${I18n.t('page.admin.form.intelliviewType.infoMessagePrefix')}`} <VisibilityIcon
                                      fontSize="small"
                                      style={{
                                        marginLeft: 4, marginRight: 4, transform: 'translateY(5px)', color: '#767676'
                                      }}
                                  /> {I18n.t('page.admin.form.intelliviewType.secondaryVideoSufixMessage')}
                            </span>
                                </Fragment>)
                            }
                            { isInteliviewDisabled && (
                                <div style={{color: '#C4212A'}}>
                                  {I18n.t('page.admin.form.intelliviewType.inactiveMessage')}
                                </div>)
                            }
                          </div>
                        </div>

                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>

                  <DVRToolkitPasswordSection
                      settings={settings}
                      system={system}
                      onChange={this.handleSettingsChange}
                  />
                  {(!systemId || systemId !== 'geotab') &&
                      <ExpansionPanel id="panel3">
                        <ExpansionPanelSummary id="restrictUser_panel" expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="h3">{I18n.t('page.admin.form.restrictUser.title')}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <div className="admin__checkboxinfo">
                            <Checkbox
                                id="ck_terminal"
                                checked={settings.useTerminal}
                                label={I18n.t('page.admin.form.restrictUser.terminal')}
                                onChange={this.handleChangeTerminal}
                            />
                            <Tooltip title={I18n.t('page.admin.form.restrictUser.terminalHelp')}>
                              <Icon className="admin__fieldinfo-icon">info</Icon>
                            </Tooltip>
                          </div>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>}
                  <ExpansionPanel id="panel4">
                    <ExpansionPanelSummary id="videoAndDriver_panel" expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h3">{I18n.t('page.admin.form.videoAndDriver.title')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <Grid container className="admin__overspeedrow">
                        <Grid item md={6} xs={12}>
                          <div className="admin__checkboxinfo">
                            <Checkbox
                                id="ck_reviewScore"
                                checked={settings.scoring !== false}
                                label={I18n.t('page.admin.form.videoAndDriver.reviewScore')}
                                onChange={this.handleChangeScoring}
                            />
                            <Tooltip title={I18n.t('page.admin.form.videoAndDriver.reviewScoreHelp')}>
                              <Icon className="admin__fieldinfo-icon">info</Icon>
                            </Tooltip>
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className="admin__fieldinfo">
                            <TextField
                                type="number"
                                error={!settingsValid.overSpeed}
                                value={settings.overSpeed}
                                onChange={this.handleChangeSpeed('overSpeed')}
                                onBlur={this.handleBlurSpeed('overSpeed')}
                                label={I18n.t('page.admin.form.videoAndDriver.overPostedSpeed.caution.label')}
                                inputProps={{
                                  min: '0',
                                  pattern: '[0-9\/]*'
                                }}
                            />
                            <OverPostedSpeedTooltip type="caution">
                              <Icon className="admin__fieldinfo-icon">info</Icon>
                            </OverPostedSpeedTooltip>
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className="admin__checkboxinfo">
                            <Checkbox
                                id="ck_gpsSpeed"
                                checked={settings.gpsSpeed !== false}
                                label={I18n.t('page.admin.form.videoAndDriver.gpsSpeed')}
                                onChange={this.handleChangeGPSSpeed}
                            />
                            <Tooltip className="classTest" title={I18n.t('page.admin.form.videoAndDriver.gpsSpeedHelp')}>
                              <Icon className="admin__fieldinfo-icon">info</Icon>
                            </Tooltip>
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className="admin__fieldinfo">
                            <TextField
                                error={!settingsValid.excessiveOverSpeed}
                                type="number"
                                value={settings.excessiveOverSpeed}
                                onChange={this.handleChangeSpeed('excessiveOverSpeed')}
                                onBlur={this.handleBlurSpeed('excessiveOverSpeed')}
                                label={I18n.t('page.admin.form.videoAndDriver.overPostedSpeed.warning.label')}
                                inputProps={{
                                  min: settingsValid.overSpeed ? toInteger(settings.overSpeed) + 1 : '0',
                                  pattern: '[0-9\/]*'
                                }}
                            />
                            <OverPostedSpeedTooltip type="warning">
                              <Icon className="admin__fieldinfo-icon">info</Icon>
                            </OverPostedSpeedTooltip>
                          </div>
                          {!settingsValid.excessiveOverSpeed && <FormHelperText className="admin__fieldinfo-errormsg" id="error-text"><span>{I18n.t('page.admin.form.videoAndDriver.overPostedSpeed.warning.invalid')}</span></FormHelperText>}
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className="admin__checkboxinfo">
                            <Checkbox
                                id="ck_enableBlinker"
                                checked={settings.blinker === true}
                                label={I18n.t('page.admin.form.videoAndDriver.blinker')}
                                onChange={this.handleChangeBlinker}
                            />
                            <Tooltip className="classTest" title={I18n.t('page.admin.form.videoAndDriver.blinkerHelp')}>
                              <Icon className="admin__fieldinfo-icon">info</Icon>
                            </Tooltip>
                          </div>
                        </Grid>
                      </Grid>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel id="panel8">
                    <ExpansionPanelSummary id="videoRetention_panel" expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h3">{I18n.t('page.admin.form.videoRetention.title')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <Grid container className="admin__overspeedrow">
                        <Grid item xs={4}>
                          <div className="admin__fieldinfo">
                            <TextField
                                error={settingsValid.exceededMaxDbRetention || !settingsValid.validDbRetention}
                                value={dataRetention.current.value || ''}
                                label={I18n.t('page.admin.form.videoRetention.dbRetention')}
                                onChange={this.handleDbRetentionChange('dbRetention')}
                                onBlur={this.handleBlurDbRetention('dbRetention')}
                                inputProps={{
                                  min: '0',
                                  pattern: '/^[0-9]*$/'
                                }}
                            />
                          </div>
                          {!settingsValid.exceededMaxDbRetention && settingsValid.validDbRetention && dataRetentionWarning && <FormHelperText className="admin__fieldinfo-errormsg" id="error-text"><span>{I18n.t('page.admin.form.videoRetention.warningMessage', {current: (dataRetention.current.value === null ? 0 : dataRetention.current.value), previous: (dataRetention.previous.value === null ? 0 : dataRetention.previous.value)})}</span></FormHelperText>}
                          {settingsValid.exceededMaxDbRetention && <FormHelperText className="admin__fieldinfo-errormsg" id="error-text"><span>{I18n.t('page.admin.form.videoRetention.exceededMaxRetentionDaysWarning')}</span></FormHelperText>}
                          {!settingsValid.validDbRetention && <FormHelperText className="admin__fieldinfo-errormsg" id="error-text"><span>{I18n.t('page.admin.form.videoRetention.invalidRetentionDaysWarning')}</span></FormHelperText>}

                        </Grid>
                        <Grid item xs={12}>
                          <div className="admin__info-cont">
                            <Icon className="admin__info-icon admin__info-icon-top">info</Icon>
                            {I18n.t('page.admin.form.videoRetention.infoMessage')}
                          </div>
                        </Grid>
                        <Grid item md={12}>
                          <Typography variant="caption">{I18n.t('page.admin.form.videoRetention.sdRetention')}</Typography>
                          <div className="admin__checkboxinfo">
                            <Checkbox
                                id="max_storage_capacity"
                                checked={sdCardRetention.checkMaxStorage.enabled}
                                label={I18n.t('page.admin.form.videoRetention.maxStorage')}
                                onChange={this.handleSdCardStorageChange}
                            />
                          </div>
                          {!sdCardRetention.checkMaxStorage.enabled && <><div className="admin__fieldinfo">
                            {<Input value={sdCardRetention.maxStorageInDays.value || ''}
                                    error={!settingsValid.sdCardRetentionMaxDaysValid}
                                    endAdornment={<InputAdornment position="end">days</InputAdornment>}
                                    onChange={this.handleMaxStorageChange}
                                    inputProps={{
                                      min: '0',
                                      pattern: '/^[0-9]*$/'
                                    }}
                            />}
                          </div>{!settingsValid.sdCardRetentionMaxDaysValid && <FormHelperText className="admin__fieldinfo-errormsg" id="error-text"><span>{I18n.t('page.admin.form.videoRetention.sdRetentionMaxWarning')}</span></FormHelperText>}</>}
                        </Grid>
                      </Grid>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>

                  <Grid container>
                    <Grid item md={12}>
                      <div className="admin__actions">
                        {isSaved && (<div className="feedbackmsg feedbackmsg__success"><Icon className="feedbackmsg__success-icon">done</Icon>{I18n.t('page.admin.form.success')}</div>)
                        }
                        <Button
                            variant="contained"
                            className="btn btn-primary admin__savebt"
                            onClick={this.handleSave}
                            id="save"
                            disabled={this.props.userCanSave === false || isSaving || !settingsValid.excessiveOverSpeed || !validation.ok || !settingsValid.sdCardRetentionMaxDaysValid || settingsValid.exceededMaxDbRetention || !settingsValid.validDbRetention}
                        >
                          {isSaving && (<CircularProgress className="btn__loading btn__loading-primary  btn__floatingcirc" />)
                          }
                          {I18n.t('action.save')}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
            }
          </Grid>
        </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const oerTypes = get(state, 'libraryFilters.oerTypes', []);
  const terminals = get(state, 'libraryFilters.terminals', []);
  const groups = get(state, 'libraryFilters.groups', []);
  const system = get(state, 'system', {});
  const userInfo = get(state, 'user.userInformation', {});

  return {
    oerTypes,
    terminals,
    groups,
    system,
    ...state.customer,
    ...state.i18n.locale,
    userInfo
  };
};
export default connect(mapStateToProps, {
  saveSettings,
  saveDBEPolicy,
  getSettings,
  loadOerTypes,
  loadGroups,
  loadTerminals
})(Settings);
